import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "@/context/LangContext";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import ParentPortal from "@/pages/ParentPortal";
import Panel from "@/pages/Panel";
import AdminApp from "@/pages/admin/AdminApp";
import POS from "@/pages/POS";
import Kiosk from "@/pages/Kiosk";
import Styleguide from "@/pages/Styleguide";

function App() {
    return (
        <div className="App">
            <LangProvider>
                <BrowserRouter>
                    <AuthProvider>
                        <Routes>
                            <Route path="/" element={<Landing />} />
                            <Route path="/login" element={<Login />} />
                            <Route path="/styleguide" element={<Styleguide />} />
                            <Route path="/kiosk" element={<Kiosk />} />
                            <Route
                                path="/portal"
                                element={
                                    <ProtectedRoute roles={["parent"]}>
                                        <ParentPortal />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/pos"
                                element={
                                    <ProtectedRoute roles={["cafeteria_operator", "super_admin"]}>
                                        <POS />
                                    </ProtectedRoute>
                                }
                            />
                            <Route
                                path="/panel"
                                element={
                                    <ProtectedRoute roles={["super_admin", "school_admin", "cafeteria_operator"]}>
                                        <AdminApp />
                                    </ProtectedRoute>
                                }
                            />
                            <Route path="*" element={<Navigate to="/" replace />} />
                        </Routes>
                    </AuthProvider>
                </BrowserRouter>
            </LangProvider>
            <Toaster position="top-right" richColors closeButton />
        </div>
    );
}

export default App;
